import {call, put} from 'redux-saga/effects';
import {receiveAwardsData} from "../actions/awardsActions";
import {fetchAwardsData} from "../api/fetchAwardsData";

export default function* getAwardsData(action) {
  try {
    const awardsData = yield call(fetchAwardsData);
    yield put(receiveAwardsData(awardsData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/awardsSaga.js